import { useEffect, useId, useRef, useState } from "react";
import { Info, Key, Users } from "@phosphor-icons/react";
import { useTranslation } from "react-i18next";
import styles from "./LinkSecurityNote.module.css";

export function LinkSecurityNote() {
  const { t } = useTranslation();
  return (
    <aside className={styles.note} aria-label={t("admin.linkSecurity.title")}>
      <div className={styles.head}>
        <span className={styles.headIcon}>
          <Info size={20} weight="regular" />
        </span>
        <strong className={styles.title}>{t("admin.linkSecurity.title")}</strong>
      </div>
      <ul className={styles.list}>
        <li className={styles.item}>
          <Key size={18} weight="regular" className={styles.itemIcon} />
          <span>{t("admin.linkSecurity.adminLink")}</span>
        </li>
        <li className={styles.item}>
          <Users size={18} weight="regular" className={styles.itemIcon} />
          <span>{t("admin.linkSecurity.userLink")}</span>
        </li>
      </ul>
    </aside>
  );
}

export function LinkSecurityHint() {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const wrapRef = useRef<HTMLSpanElement>(null);
  const popoverId = useId();

  useEffect(() => {
    if (!open) return;
    const onDown = (e: globalThis.MouseEvent) => {
      if (wrapRef.current && !wrapRef.current.contains(e.target as Node)) {
        setOpen(false);
      }
    };
    const onKey = (e: globalThis.KeyboardEvent) => {
      if (e.key === "Escape") setOpen(false);
    };
    window.addEventListener("mousedown", onDown);
    window.addEventListener("keydown", onKey);
    return () => {
      window.removeEventListener("mousedown", onDown);
      window.removeEventListener("keydown", onKey);
    };
  }, [open]);

  return (
    <span className={styles.hintWrap} ref={wrapRef}>
      <button
        type="button"
        className={styles.hintTrigger}
        aria-label={t("admin.linkSecurity.iconLabel")}
        aria-expanded={open}
        aria-controls={open ? popoverId : undefined}
        onClick={() => setOpen((v) => !v)}
      >
        <Info size={18} weight="regular" />
      </button>
      {open && (
        <span id={popoverId} role="tooltip" className={styles.popover}>
          {t("admin.linkSecurity.short")}
        </span>
      )}
    </span>
  );
}
